export const users = [
  {
    id: null,
    avatar: null,
    email: null,
    name: null,
    password: null,
    plan:null
  }
];
